module.exports = __webpack_public_path__ + "img/zlk.a78c4f2a.png";